// Búsqueda de la agenda del especialista: matchea una solicitud por su
// N° de solicitud (`item.id`) o su N° de mantención (`item.id_mantencion`).
// Match parcial (substring). Query vacío/espacios = sin filtro (devuelve true).
export function matchesSolicitudNumero(item, query) {
  const q = String(query ?? '').trim();
  if (!q) return true;
  const solicitud = String(item?.id ?? '');
  const mantencion = String(item?.id_mantencion ?? '');
  return solicitud.includes(q) || mantencion.includes(q);
}
